export default __webpack_public_path__ + "static/media/sign_hero.6911f9d5.png";